/*
 * @Author: your name
 * @Date: 2020-05-26 19:40:04
 * @LastEditTime: 2020-06-11 16:27:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import api from './api'
import common from './common'
import ElementUI from 'element-ui';
import localeEn from 'element-ui/lib/locale/lang/en';
import localeEs from 'element-ui/lib/locale/lang/es';
import localeIt from 'element-ui/lib/locale/lang/it';
import localeFr from 'element-ui/lib/locale/lang/fr';
import infiniteScroll from 'vue-infinite-scroll'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import VueMeta from 'vue-meta'
import Print from 'vue-print-nb'

require('./components/index')
require('./utils/init_property_method');//在程序开始前先初始化一些属性和方法
// import MetaInfo from 'vue-meta-info'

// import 'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper, /* { default global options } */)
// import VueAwesomeSwiper from 'vue-awesome-swiper'

// import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css'
import "./assets/stylesheets/common.less";
import VueLazyload from 'vue-lazyload'

let elOption = getElLangOpt();
//生产环境才使用vue-meta进行配置，meta数据
if (process.env.NODE_ENV === 'production') {
    Vue.use(VueMeta);
}
Vue.use(ElementUI, {locale: elOption});
Vue.use(infiniteScroll);
Vue.use(VueLazyload, { //只能用于http网页地址的img 使用方法 v-lazy=''
    preLoad: 1.3,
    error: require('@/assets/img/empty_default.jpg'),   //请求失败后显示的图片
    loading: require('@/assets/img/empty_default.jpg'),   //加载的loading过渡图片
    attempt: 1     // 加载图片数量
})
// Global instruction
Vue.use(Print);
Vue.component(CollapseTransition.name, CollapseTransition)
// Vue.use(MetaInfo)
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$common = common
Vue.prototype.$langPage = store.state.langPage;
new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    mounted() {
        // document.dispatchEvent(new Event('render-event')) //prerender打包功能
    }
}).$mount('#app')


//获取element ui的多语言配置
function getElLangOpt() {
    let lang = localStorage.getItem('lang') || 'fr';
    if (lang == 'fr') return localeFr;
    if (lang == 'en') return localeEn;
    if (lang == 'es') return localeEs;
    if (lang == 'it') return localeIt;
}
